import React, { useState } from 'react';
import { Container, Row, Col, Form, Alert } from 'react-bootstrap';
import axios from 'axios';

const BudgetBuddy = () => {
  const [prompt, setPrompt] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [messages, setMessages] = useState([]);

  const apiEndpoint = process.env.REACT_APP_AI_API_GATEWAY_URL;
  const apiKey = process.env.REACT_APP_AI_API_KEY;

  // Validate prompt to ensure at least 2 words
  const validatePrompt = (prompt) => {
    const wordCount = prompt.trim().split(/\s+/).length;
    if (wordCount < 2) {
      setIsValid(false);
      setErrorMessage('Please enter at least 2 words.');
      return false;
    }
    setIsValid(true);
    setErrorMessage('');
    return true;
  };

  const handlePromptChange = (e) => {
    const { value } = e.target;
    setPrompt(value);
    validatePrompt(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setResponseMessage(null);
    setErrorMessage('');

    if (!validatePrompt(prompt)) return;

    setLoading(true);

    const modifiedPrompt = `
    Prompts should serve finances and investments questions only. 
    If the question is not related to this, please inform the user politely about the purpose of this application.
    If the question is related to finance or investments, please proceed to provide an answer. The users are beginners so responses should be easily understood.

    User's question: ${prompt}
  `;
    try {
      const requestData = {
        body: { prompt: modifiedPrompt }
      };

      const headers = {
        Accept: 'application/json',
        'x-api-key': apiKey
      };

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(requestData),
        contentType: 'application/json'
      });

      if (response.status === 200 || response.ok) {
        const data = await response.json();
        const message = data.customMessage.result[0].message;

        if (message) {
          const boldMessage = message.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>").replace(/###(.*?)###/g, "<h3>$1</h3>");
          setResponseMessage(boldMessage);
          setMessages([...messages, { prompt, response: boldMessage }]);
        } else {
          setErrorMessage('Message is empty in the response.');
        }
      } else {
        setErrorMessage("Message not found in the response.");
      }
    } catch (error) {
      setLoading(false);
      console.error('API Error:', error);
      setErrorMessage('Error calling the API. Please try again later.');
    }
    setLoading(false);
    setPrompt(''); // Clear the input box after submission
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <Container fluid style={{ padding: 0 }}>
      <Row className="justify-content-center" style={{ height: '100vh', margin: 0 }}>
        <Col md={10} xs={12} style={{
          backgroundColor: '#fff',
          padding: '40px',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          height: '85%',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <h4 style={{ textAlign: 'center', color: '#333', marginBottom: '20px' }}>Budget Buddy: Ask your financial questions</h4>

          {/* Response area with scroll */}
          <div style={{
            flexGrow: 1,
            marginBottom: '20px',
            overflowY: 'auto',
            padding: '10px',
            backgroundColor: '#f8f8f8',
            borderRadius: '8px',
            border: '1px solid #ddd',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start'
          }}>
            {messages.map((msg, index) => (
              <div key={index} style={{ marginBottom: '15px' }}>
                <div style={{
                  padding: '10px',
                  backgroundColor: '#e0f7fa',
                  borderRadius: '8px',
                  fontSize: '14px',
                  marginBottom: '5px',
                  wordBreak: 'break-word'
                }}>
                  <strong>User:</strong> {msg.prompt}
                </div>
                <div style={{
                  padding: '10px',
                  backgroundColor: '#f1f8e9',
                  borderRadius: '8px',
                  fontSize: '14px',
                  wordBreak: 'break-word'
                }}>
                  <strong>Response:</strong> <div dangerouslySetInnerHTML={{ __html: msg.response }} />
                </div>
              </div>
            ))}

            {/* Show thinking message if loading */}
            {loading && (
              <div style={{
                padding: '10px',
                backgroundColor: '#FFF3CD',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '5px',
                wordBreak: 'break-word',
                color: '#856404',
                textAlign: 'center'
              }}>
                <strong>Thinking...</strong>
              </div>
            )}
          </div>

          {/* Input prompt section with submit button next to the input box */}
          <Form onSubmit={handleSubmit} style={{ display: 'flex' }}>
            <Form.Group controlId="formPrompt" style={{ flexGrow: 1 }}>
              <Form.Control
                as="textarea"
                rows={1}
                value={prompt}
                onChange={handlePromptChange}
                onKeyDown={handleKeyPress} // Listen for Enter key
                placeholder="Type your question here..."
                isInvalid={!isValid}
                style={{
                  borderRadius: '8px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  padding: '12px',
                  fontSize: '16px',
                  border: '1px solid #ddd',
                  marginBottom: '10px',
                  resize: 'none',
                  marginRight: '10px'
                }}
              />
              <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
            </Form.Group>

            {/* go button for submit */}
            <div 
              onClick={handleSubmit} 
              style={{
                cursor: 'pointer',
                fontSize: '15px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '10px',
                backgroundColor: '#4CAF50',
                borderRadius: '50%',
                color: '#fff',
                width: '40px',
                height: '40px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                textAlign: 'center'
              }}
            >
              Go!
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default BudgetBuddy;
